import React from "react";
import { TabBarRoot, TabBarButton } from "./style.js";

// ── TabBar ────────────────────────────────────────────────────────────────────
const TabBar = ({ tabs, active, onChange }) => (
  <TabBarRoot>
    {tabs.map((t) => {
      const isActive = t.id === active;
      return (
        <TabBarButton
          key={t.id}
          $isActive={isActive}
          onClick={() => onChange(t.id)}
        >
          {t.label}
        </TabBarButton>
      );
    })}
  </TabBarRoot>
);

export default TabBar;
